module.exports = __webpack_public_path__ + "img/145.ff68cc60.jpg";